import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { SHOULD_SHOW_TOOLTIP, TOOLTIP_DETAILS, SHOW_FEATURE_COMPLETE_TOOLTIP, SET_CURRENT_SCREEN } from '../actions/types';
var initialState = {
  shouldShowTooltip: false,
  tooltipDetails: {},
  featureComplete: false,
  currentScreen: ''
};
export var tooltipReducer = function tooltipReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case SHOULD_SHOW_TOOLTIP:
      return _objectSpread(_objectSpread({}, state), {}, {
        shouldShowTooltip: action.payload
      });

    case TOOLTIP_DETAILS:
      var tooltipDetails = _objectSpread(_objectSpread({}, state.tooltipDetails), {}, {
        tooltipDetails: action.payload
      });

      return _objectSpread(_objectSpread({}, state), {}, {
        tooltipDetails: tooltipDetails
      });

    case SHOW_FEATURE_COMPLETE_TOOLTIP:
      return _objectSpread(_objectSpread({}, state), {}, {
        featureComplete: action.payload
      });

    case SET_CURRENT_SCREEN:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentScreen: action.payload
      });

    default:
      return state;
  }
};